import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal, MaskLines, Eyebrow } from "./motion";

export const Learning = () => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section id="aprendizagem" ref={ref} data-testid="learning-section" className="relative overflow-hidden bg-navy py-28 text-white sm:py-44">
      <motion.img style={{ y }} src="/img/familia.jpg" alt="Família a caminhar na praia ao pôr do sol" className="absolute inset-0 h-[124%] w-full -translate-y-[12%] object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/85 to-navy/30" />
      <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="max-w-3xl">
          <Eyebrow dark num="07">A minha maior aprendizagem</Eyebrow>
          <h2 className="mt-6 font-display text-3xl font-black leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
            <MaskLines lines={["O sucesso não vale a pena", "se perdermos aquilo que", <span className="text-orange">realmente importa.</span>]} />
          </h2>
          <Reveal className="mt-12 space-y-5 text-base leading-relaxed text-slate-200 sm:text-lg">
            <p>Ao longo da minha vida aprendi a construir empresas.</p>
            <p className="font-display text-2xl font-extrabold text-white sm:text-3xl">Mas a maior lição chegou quando o meu corpo me obrigou a parar.</p>
            <p>Percebi que nenhum crescimento justifica sacrificar a saúde, a família ou a vida pessoal.</p>
            <p>Hoje continuo a acreditar na ambição. Continuo a acreditar no crescimento.</p>
          </Reveal>
          <Reveal className="mt-12 border-l-4 border-orange pl-6">
            <p className="font-display text-2xl font-extrabold leading-tight sm:text-4xl" data-testid="learning-quote">
              Mas acredito que o verdadeiro sucesso é aquele que conseguimos viver.
            </p>
            <p className="mt-5 text-sm text-slate-300 sm:text-base">É essa visão que procuro transmitir a todos os empresários da nossa rede.</p>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
